import React from "react";
import {Chip} from "@mui/material";
import {CONSTANTS} from "../../common/constants";
import {formatCurrency} from "../../common/Utils";

import LoopIcon from '@mui/icons-material/Loop';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import DiscountIcon from '@mui/icons-material/Discount';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
export default function MembershipPerks({inventory}) {

  const displayPerk = (perk) => {
    return perk.name;
  }

  const perkIcon = (perk) => {

    if (perk.unlimitedUsage) {
      return <LoopIcon />;
    }
    if (perk?.perkType?.id === CONSTANTS.PERK_TYPE.PRODUCT) {
      return <ShoppingBagIcon />;
    }
    if (perk?.perkType?.id === CONSTANTS.PERK_TYPE.DISCOUNT) {
      return <DiscountIcon />;
    }
    if (perk?.perkType?.id === CONSTANTS.PERK_TYPE.CREDIT) {
      return <LocalOfferIcon />;
    }
    return <ThumbUpAltIcon />;
  }

  return (
    <>
      {inventory?.memberPerks?.length > 0 && <div className={'d-block my-2'}>
        <p className={'m-0'}><b>Membership Perks</b></p>
        {inventory?.memberPerks?.map((perk, idx)=> {
          return (
            <Chip key={idx} icon={perkIcon(perk)} className="m-chip" variant="outlined" label={displayPerk(perk)} />
          )
        })}
      </div>}
    </>
  )
}